import { render, staticRenderFns } from "./NewQrCodePage.vue?vue&type=template&id=19fd68e4&"
import script from "./NewQrCodePage.vue?vue&type=script&lang=js&"
export * from "./NewQrCodePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports